import { Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@components/button/button.component';
import { AlertComponent } from '@components/alert/alert.component';
import { BadgeStatusComponent } from '@components/badge-status/badge-status.component';
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { AccountType } from '../../../interfaces/api/AccountType';
import { ApiService, UserInfo } from '../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms'
import { environment } from '../../../../environments/environment'
import { LanguageParserService } from '../../../services/language-parser.service'
import { SalesforceService } from '../../../services/salesforce.service'

@Component({
    selector: 'app-samples-detail',
    templateUrl: './samples-detail.component.html',
    styleUrls: ['./samples-detail.component.scss'],
    standalone: true,
    imports: [TranslateModule, FormsModule, ButtonComponent, AlertComponent, CommonModule, BadgeStatusComponent, CosentinoSvgComponent, SlickCarouselModule],
    encapsulation: ViewEncapsulation.None,
})
export class SamplesDetailComponent implements OnInit {
    @Input() sample: any
    @ViewChild('nameInput') nameInput!: ElementRef; // Reference to the input element
    id: string
    userInfo: UserInfo
    tempName: string = ''
    editNameMode: boolean = false
    isSaving: boolean = false; // Flag to avoid conflicts between blur and click

    constructor(
        private api: ApiService,
        private router: Router,
        private route: ActivatedRoute,
        private languageParser: LanguageParserService,
        private canvas: SalesforceService
    ) { }
    protected readonly AccountType = AccountType
    @Output() clickCustom = new EventEmitter()
    slideConfig = {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: false,
        dotsClass: 'slick-dots-we',
        nextArrow:
            '<svg style="position:absolute;top:42%;right:0;z-index:10;cursor:pointer;" c-cosentinoSvg_chevronRight="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.39995L9.4002 6.69995L14.7002 12L9.4002 17.3Z" fill="#232323"/></path></svg>',
        prevArrow:
            '<svg style="position:absolute;top:42%;z-index:10;cursor:pointer;" c-cosentinoSvg_chevronLeft="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.0002 17.3L8.7002 12L14.0002 6.69995L14.7002 7.39995L10.1002 12L14.7002 16.6L14.0002 17.3Z" fill="#232323"/></path></svg>',
    }
    ngOnInit() {
        this.api.userInfo.subscribe((userInfo) => (this.userInfo = userInfo))
     
        this.route.params.subscribe((params) => {
            this.id = params['id']
        })
        this.fetchSample()

        console.log(AccountType.isCtop(this.userInfo.accountType) ? 'Ctop user' : 'Non-Ctop user')
    }
    fetchSample() {
        this.api.getSampleDetail(this.id).subscribe((sample) => {
            this.sample = sample;
            console.log(this.sample)
        })
    }



    /**
     * Devuelve el estado de la muestra según la lógica de negocio (igual que en my-samples)
     */
    getStatus(): 'draft' | 'inprogress' | 'indelivery' | 'delivered' | 'error' {
        const s = this.sample;
        console.log(s)
        if (!s) return 'error';
        if (s.status === 'Pending') return 'draft';
        if (s.status === 'Activated') return 'inprogress';
        if (s.status === 'Preparing' && s.shippingType === 'Logistic provider') return 'inprogress';
        if (s.status === 'Preparing' && s.shippingType === 'Business visit') return 'inprogress';
        if (s.status === 'Sent' && s.shippingType === 'Logistic provider') return 'indelivery';
        if (s.status === 'Delivered') return 'delivered';
        return 'error';
    }

    getStatusBadgeLabel(): string {
        switch (this.getStatus()) {
            case 'draft': return 'order_samples.draft';
            case 'inprogress': return 'order_samples.inprogress';
            case 'indelivery': return 'order_samples.indelivery';
            case 'delivered': return 'order_samples.delivered';
            case 'error': return 'order_samples.error';
        }
    }
            getStatusIconClass(): string {
        return this.getStatus();
    }

        continueOrAddMore(sample: any) {
        const lang = this.languageParser.getShortLanguage(this.userInfo?.locale)
        const samplesUrl = `${environment.samplesEndpoint}?language=${lang}`
        if(this.canvas.isCanvas() && window.top){
            window.top.postMessage({
                type: "navigateTo",
                communityPage: "",
                externalUrl: samplesUrl,
                params: "",
                newTab: false
            }, environment.salesforceUrl);
        } else {
            window.location.href = samplesUrl;
        }
    }

    // continueOrAddMore(sample: any) {
    //     this.clickCustom.emit(sample)
    // }

    onViewDetails(sample: any) {
        this.router.navigate(['/my-rewards'])
    }

    goToMySamples() {
        this.router.navigate(['/my-samples']);
    }

    goToCart() {
        console.log('Navigating to cart...');
        const lang = this.languageParser.getShortLanguage(this.userInfo?.locale)
        const samplesUrl = `${environment.samplesEndpoint}?language=${lang}`
        if(this.canvas.isCanvas() && window.top){
            window.top.postMessage({
                type: "navigateTo",
                communityPage: "",
                externalUrl: samplesUrl,
                params: "",
                newTab: false
            }, environment.salesforceUrl);
        } else {
            window.location.href = samplesUrl;
        }
    }

   onEditName() {
       console.log('Editing name...');
        this.tempName = this.sample.alias !== null ? this.sample.alias : this.sample.name
        this.editNameMode = true

        // Focus the input element
        setTimeout(() => {
            if (this.nameInput) {
                this.nameInput.nativeElement.focus();
            }
        }, 100);
    }

    onSaveNameEdit(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        this.isSaving = true; // Indicate that saving is in progress
        this.saveNameEdit();
    }

    saveNameEdit() {
          if (this.tempName.trim() === '') {
            this.tempName = this.sample.name;
        }
        this.api.editSampleAlias(this.sample.id, this.tempName).subscribe(() => {
            this.editNameMode = false;
            this.sample.alias = this.tempName;
            this.isSaving = false; // Reset the flag after saving
        });
    }
     cancelNameEdit() {
        if (this.isSaving) return; // Avoid canceling if saving is in progress
        this.editNameMode = false
    }


}